import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from 'components/Loader/index';
import GridWrapper from '../../../../../custom-hooks/GridWrapper';
import { setApi } from 'reducers/grid';

const ObjectsList = (props) => {
    const {
        id,
        updateApiGrid,
        history,
        objectType,
        relObjectTypes,
    } = props;

    const [loadingState, setLoadingState] = useState(true);

    const init = {
        key: 'objects_links',
        relObjectTypes: relObjectTypes,
        pathParams: {
            id,
            objectType,
        },
        extra: `${id}_${relObjectTypes}`,
    };

    const gridKey = `${init.key}_${init.path || init.extra || ''}`;

    const getParams = () => ({
        selectItem: (item) => {
            history.push(`/${item.objectType.toLowerCase()}/${item.id}/0`);
        },
    });

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    useEffect(() => {
        id && updateApiGrid({ page: 1 }, gridKey);
    }, [id]);

    return (
        <div className="content-wrapper with-fixed-status">
            {loadingState && <Loader />}
            <GridWrapper
                tuner={() => init}
                initUpdate={false}
                gridParams={getParams()}
                onStart={onStart}
                onFinish={onFinish}
                destroyOnUnmount
            />
        </div>
    );
};

export default connect(null, { updateApiGrid: setApi })(withRouter(ObjectsList));
